<template>
	<md-card>
		<md-card-header class="md-card-header-icon">
			<div class="card-icon">
				<i class="md-icon fas fa-user" style="color: white"></i>
			</div>
			<h4 class="title">
				Information du profil
			</h4>
		</md-card-header>

		<md-card-content>
			<div class="md-layout spacing">
				<label class="md-layout-item md-size-15 md-form-label">
					Nom
				</label>
				<div class="md-layout-item">
					<md-field class="md-invalid">
						<md-input v-model="userName" disabled />
					</md-field>
				</div>
			</div>

			<div class="md-layout">
				<label class="md-layout-item md-size-15 md-form-label">
					Email
				</label>
				<div class="md-layout-item">
					<md-field class="md-invalid">
						<md-input v-model="user.email" disabled />
					</md-field>
				</div>
			</div>
		</md-card-content>
	</md-card>
</template>

<script>
export default {
	name: "user-profile-card",
	props: {
		user: Object,
	},
	computed: {
		userName: function() {
			return this.user.first_name + ' ' + this.user.last_name
		}
	},
};
</script>

<style lang="scss">
.spacing {
	padding-bottom: 1rem;
}
</style>
